import * as React from 'react';
import { Box, Checkbox, FormControlLabel, } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Typography from '@material-ui/core/Typography';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { PulseLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import { colors } from '../../../constants/colors';
import { ITeamRegForm } from '../../../types/auth';
import { createTeam } from '../../../redux/actions/auth';
import { RootState } from '../../../redux/store';
import { Button, makeStyles, MenuItem, Select, Theme } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { COUNTRIES } from '../../../constants/data';
import { Card as MuiCard } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import logo from '../../../assets/logo.png'

// Phone number utility - only digits, max 10
const sanitizePhoneNumber = (value: string): string => {
  // Remove all non-numeric characters and limit to 10 digits
  return value.replace(/[^\d]/g, '').slice(0, 10);
};
const useStyles = makeStyles((theme: Theme) => ({
  textField: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: '#F5F5F5',
    borderRadius: '10px'
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    alignItems: 'center',
    backgroundColor: '#EDF2F7',
    padding: theme.spacing(2),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    maxWidth: '500px',
    padding: theme.spacing(4),
    gap: '8px',
    margin: 'auto',
    boxShadow:
      'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
    borderRadius: theme.spacing(1),
    backgroundColor: '#FFF'
  },
  title: {
    fontSize: '2.75rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  form: {
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(5),
    margin: 'auto',
    minWidth: 400,
    [theme.breakpoints.down(479)]: {
      minWidth: 'fit-content',
    },
  },
  
  titleCon: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  loginTitle: {
    color: '#3b3b3b',
    fontSize: 20,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  inputStyle: {
    border: 0,
    backgroundColor: 'white',
    color: '#000000',
  },
  dividerContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: `${theme.spacing(1)}px 0`,
  },
  dividerLine: {
    flexGrow: 1,
    height: '1px',
    backgroundColor: theme.palette.divider,
  },
  dividerText: {
    margin: `0 ${theme.spacing(1)}px`,
    color: '#706C7C',
    fontWeight: 200,
    fontSize: 18
  },
  formLabel: {
    color: "#2158D0",
    display: 'block',
    textAlign: 'left',
    fontWeight: 700,
    fontSize: '20px',
    lineHeight: '28.79px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    marginTop: '0px',
    marginBottom: '-8px'
  },
  checkBoxWrapper: {
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      color: '#2158D0',
      fontWeight: 700,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
  },
  submitBtn: {
    background: '#5C91FF',
    color: '#FFFFFF',
    textTransform: 'capitalize',
    borderRadius: 6,
    padding: '11px 11px',
    marginBottom: theme.spacing(2),
    '&:hover': {
      background: '#5C91FF'
    },
    fontWeight: 700,
    fontSize: '20px'
  },
  paragraphText: {
    display: 'block',
    textAlign: 'center',
    color: '#000000',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '28.79px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  singupLink: {
    color: "#2158D0",
    cursor: 'pointer',
    textDecoration: 'none'
  },




}))
interface PropsType {
  authError: string;
  userStatus: boolean;
  createTeam: (data: ITeamRegForm) => any;
}

function Register(props: PropsType) {
  const { createTeam, userStatus } = props;
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [invitationEmail, setInvitationEmail] = useState('');
  const [invitationPhone, setInvitationPhone] = useState('');
  const [communityName, setCommunityName] = useState('');
  const [invitationError, setInvitationError] = useState('');
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const invitation = queryParams.get('invitation');
  const { control, handleSubmit, errors, setValue } = useForm();
  const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:9090";

  // Fetch invitation details on mount if invitation code exists
  useEffect(() => {
    const fetchInvitationDetails = async () => {
      if (invitation) {
        try {
          const response = await fetch(`${API_BASE}/v1/invitations/${invitation}/validate`);
          const data = await response.json();

          if (data.success && data.data.invitation) {
            const invDetails = data.data.invitation;

            // Set community name
            if (invDetails.communityName) {
              setCommunityName(invDetails.communityName);
            }

            // Pre-fill email
            if (invDetails.email) {
              setInvitationEmail(invDetails.email);
              setValue('email', invDetails.email);
            }

            // Pre-fill name (firstName and lastName come separately from invitation)
            if (invDetails.firstName) {
              setValue('name', invDetails.firstName);
            }
            if (invDetails.lastName) {
              setValue('lastName', invDetails.lastName);
            }

            // Pre-fill phone number
            if (invDetails.phoneNumber) {
              const sanitized = sanitizePhoneNumber(invDetails.phoneNumber);
              setPhoneNumber(sanitized);
              setInvitationPhone(invDetails.phoneNumber);
              setValue('phoneNumber', sanitized);
            }
          } else {
            // Handle error cases (revoked, expired, invalid, etc.)
            setInvitationError(data.message || 'This invitation is no longer valid');
          }
        } catch (error) {
          console.error('Error fetching invitation details:', error);
          setInvitationError('Unable to validate invitation. Please try again.');
        }
      }
    };

    fetchInvitationDetails();
  }, [invitation, setValue]);

  const handlePhoneNumberChange = (value: string) => {
    const sanitized = sanitizePhoneNumber(value);
    setPhoneNumber(sanitized);
    return sanitized;
  };

  const onSubmit = async (data: ITeamRegForm) => {
    setLoading(true)
    const invitation = queryParams.get('invitation');
    if (invitation) data.invitation = invitation;
    // Only include phone number if it's not empty
    if (phoneNumber && phoneNumber.trim()) {
      data.phoneNumber = phoneNumber;
    } else {
      delete data.phoneNumber;
    }
    const registerResponse = await createTeam(data);
    setLoading(false)
    if (registerResponse?.success) {
      history.push('/login', { email: data.email, fromRegister: true });
    }

  };
  const handleAgreementChange = (event) => {
    setIsAgreed(event.target.checked);
  };

  return (<>

    <div className={classes.container}>
      {
        loading ? <div className="loader-container">
          <div className="loader"></div>
        </div>
          :
          <MuiCard className={classes.card}>
            <Typography variant="h1" className={classes.title}>
              <div>
                <img
                  style={{ width: 120 }}
                  src={logo}
                  alt="Logo"
                />
              </div>
            </Typography>
            <Typography className={classes.titleCon}>
              <h1 className={classes.loginTitle}>Create your  account</h1>
            </Typography>
            {communityName && (
              <Typography style={{ textAlign: 'center', fontSize: '18px', color: '#2158D0', fontWeight: 600, marginBottom: '16px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
                Join {communityName}
              </Typography>
            )}
            {invitationError && (
              <Box style={{ backgroundColor: '#FEE', border: '1px solid #C33', borderRadius: '8px', padding: '16px', marginBottom: '16px', textAlign: 'center' }}>
                <Typography style={{ color: '#C33', fontSize: '16px', fontWeight: 600, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
                  ⚠️ {invitationError}
                </Typography>
                <Typography style={{ color: '#C33', fontSize: '14px', marginTop: '8px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
                  Please contact your community administrator for a new invitation.
                </Typography>
              </Box>
            )}
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12}>
                <Typography variant="body1" className={classes.formLabel}>
                  First Name
                </Typography>
                <Controller
                  className={classes.textField}
                  variant="outlined"
                  name="name"
                  control={control}
                  rules={{
                    required: 'First Name is required.',
                  }}
                  defaultValue=""
                  as={
                    <OutlinedInput
                      id="name"
                      aria-describedby="name-helper-text"
                      inputProps={{
                        'aria-label': 'name',
                      }}
                      labelWidth={0}
                      placeholder="First Name"
                      className={classes.inputStyle}
                    />
                  }
                />
                <ErrorMessage
                  as={<Typography color="error" />}
                  errors={errors}
                  name="name"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.formLabel}>
                  Last Name
                </Typography>
                <Controller
                  className={classes.textField}
                  variant="outlined"
                  name="lastName"
                  control={control}
                  rules={{
                    required: 'Last Name is required.',
                  }}
                  defaultValue=""
                  as={
                    <OutlinedInput
                      id="lastName"
                      aria-describedby="name-helper-text"
                      inputProps={{
                        'aria-label': 'lastName',
                      }}
                      labelWidth={0}
                      placeholder="Last Name"
                      className={classes.inputStyle}
                    />
                  }
                />
                <ErrorMessage
                  as={<Typography color="error" />}
                  errors={errors}
                  name="lastName"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.formLabel}>
                  Phone Number (Optional)
                </Typography>
                <Controller
                  className={classes.textField}
                  variant="outlined"
                  name="phoneNumber"
                  control={control}
                  rules={{
                    validate: (value) => {
                      if (!value || value.trim() === '') return true;
                      const digits = (value || '').replace(/[^\d]/g, '');
                      return digits.length === 10 || 'Please enter a valid 10-digit phone number';
                    }
                  }}
                  defaultValue=""
                  as={
                    <OutlinedInput
                      id="phoneNumber"
                      aria-describedby="phone-number-helper-text"
                      inputProps={{
                        'aria-label': 'phoneNumber',
                        maxLength: 10,
                        inputMode: 'numeric',
                        pattern: '[0-9]*'
                      }}
                      value={phoneNumber}
                      onChange={(e) => {
                        handlePhoneNumberChange(e.target.value);
                      }}
                      labelWidth={0}
                      placeholder="5551234567"
                      className={classes.inputStyle}
                    />
                  }
                />
                <ErrorMessage
                  as={<Typography color="error" />}
                  errors={errors}
                  name="phoneNumber"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" className={classes.formLabel}>
                  Email
                </Typography>
                <Controller
                  className={classes.textField}
                  variant="outlined"
                  name="email"
                  control={control}
                  rules={{
                    required: 'Email is required.',
                  }}
                  defaultValue={invitationEmail || ""}
                  as={
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      aria-describedby="outlined-weight-helper-text"
                      inputProps={{
                        'aria-label': 'email',
                      }}
                      labelWidth={0}
                      placeholder="Email"
                      className={classes.inputStyle}
                      disabled={!!invitationEmail}
                    />
                  }
                />
                <ErrorMessage
                  as={<Typography color="error" />}
                  errors={errors}
                  name="email"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" className={classes.formLabel}>
                  Password
                </Typography>
                <Controller
                  className={classes.textField}
                  variant="outlined"
                  name="password"
                  control={control}
                  rules={{
                    required: 'Password is required.',
                  }}
                  defaultValue=""
                  as={
                    <OutlinedInput
                      name="password"
                      className={classes.inputStyle}
                      id="outlined-adornment-password"
                      type={showPassword ? 'text' : 'password'}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                            style={{
                              color: '#D3C3E6',
                            }}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                      labelWidth={0}
                      placeholder="Password"
                    />
                  }
                />
                <ErrorMessage
                  as={<Typography color="error" />}
                  errors={errors}
                  name="password"
                />
              </Grid>
              <Box className={classes.dividerContainer}>
                <div className={classes.dividerLine}></div>
                <span className={classes.dividerText}>Invitation Code</span>
                <div className={classes.dividerLine}></div>
              </Box>
              <Grid item xs={12}>

                <Controller
                  className={classes.textField}
                  variant="outlined"
                  name="invitation"
                  control={control}
                  rules={{
                    required: 'Invitation Code is required.',
                  }}
                  defaultValue={invitation || ""}
                  as={
                    <OutlinedInput
                      name="invitation"
                      className={classes.inputStyle}
                      id="outlined-adornment-password"
                      labelWidth={0}
                      placeholder="Invitation"
                      disabled={!!invitation}
                    />
                  }
                />
                <ErrorMessage
                  as={<Typography color="error" />}
                  errors={errors}
                  name="invitation"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  className={classes.checkBoxWrapper}
                  control={
                    <Checkbox
                      name="agreeToTerms"
                      checked={isAgreed}
                      onChange={handleAgreementChange}
                    // color="primary"
                    // inputRef={register({ required: 'You must agree to the terms and conditions.' })}
                    />
                  }
                  label="I agree to all terms and privacy policy"

                />
                <ErrorMessage
                  as={<Typography color="error" />}
                  errors={errors}
                  name="agreeToTerms"
                />
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'center', margin: '32px 0 8px 0' }}>
                <Button type="submit" variant='contained' color='primary' size='large' fullWidth style={{ height: "50px" }} className={classes.submitBtn}
                  disabled={!isAgreed || !!invitationError}


                >
                  Sign Up
                </Button>
              </Grid>
              <Grid>
                <Typography align="center" className={classes.paragraphText}>

                  Already have an account? {''}

                  <Link to="/login" className={classes.singupLink}>
                    Log in
                  </Link>
                </Typography>
              </Grid>
              <Grid>
                <Typography align="center" className={classes.paragraphText} style={{ marginTop: 8 }}>
                  Want to create your own community?{' '}
                  <Link to="/setup" className={classes.singupLink}>
                    Set up here
                  </Link>
                </Typography>
              </Grid>
            </form>
          </MuiCard>
      }   </div>
  </>
  );
}
const mapStateToProps = (state: RootState) => ({
  authError: state.auth.authError,
  userStatus: state.auth.userStatus,
});

export default connect(mapStateToProps, { createTeam })(Register);



